<template>
  <div class="d-flex flex-row" style="gap: 8px">
    <div class="d-flex" style="font-size: 24px;">
      {{item.flag}}
    </div>
    <div class="d-flex align-self-center">
      {{capitalize(item.text)}}
    </div>
  </div>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  props: {
    item: {
      type: Object,
      required: true,
      validator(v) {
        return (
          v.lang !== undefined && v.flag !== undefined && v.text !== undefined
        );
      },
    },
  },
  methods: {
    capitalize,
  }
};
</script>

<style lang="scss" scoped></style>
